enum DeploymentStage {
  PRODUCTION = 'production',
  STAGING = 'staging',
  ALPHA = 'alpha'
}

const DeploymentProfile = 'korem';
const DeploymentFQDN = 'daisvalgroup.com';

const DeploymentRegions: Record<DeploymentStage, string> = {
  [DeploymentStage.PRODUCTION]: 'us-east-1',
  [DeploymentStage.STAGING]: 'us-east-2',
  [DeploymentStage.ALPHA]: 'us-west-1'
};

const DeploymentDomains: Record<DeploymentStage, string> = {
  [DeploymentStage.PRODUCTION]: 'pyramo.daisvalgroup.com',
  [DeploymentStage.STAGING]: 'pyramo-staging.daisvalgroup.com',
  [DeploymentStage.ALPHA]: 'pyramo-alpha.daisvalgroup.com'
};

const ApiDeploymentDomains: Record<DeploymentStage, string> = {
  [DeploymentStage.PRODUCTION]: 'api.pyramo.daisvalgroup.com',
  [DeploymentStage.STAGING]: 'api.pyramo-staging.daisvalgroup.com',
  [DeploymentStage.ALPHA]: 'api.pyramo-alpha.daisvalgroup.com'
};

const isDeploymentStage = (value: unknown): value is DeploymentStage =>
  typeof value === 'string' &&
  Object.values(DeploymentStage).includes(value as any);

export {
  DeploymentStage,
  DeploymentProfile,
  DeploymentFQDN,
  DeploymentRegions,
  DeploymentDomains,
  ApiDeploymentDomains,
  isDeploymentStage
};
